import * as React from "react"

import {
  cn
} from "@/lib/utils"

const Table = React.forwardRef<
  HTMLTableElement,
  React.HTMLAttributes<HTMLTableElement>
>(({
  className, ...props 
}, ref) => (
  <div className='relative w-full overflow-auto'>
    <table
      ref={ref}
      className={cn("w-full caption-bottom text-sm", className)}
      {...props}
    />
  </div>
))

Table.displayName = "Table"

const TableHeader = React.forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(({
  className, ...props 
}, ref) => (
  <thead ref={ref} className={cn("[&_tr]_border-b", className)} {...props} />
))

TableHeader.displayName = "TableHeader"

const TableBody = React.forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(({
  className, ...props 
}, ref) => (
  <tbody
    ref={ref}
    className={cn("[&_tr_last-child]_border-0", className)}
    {...props}
  />
))

TableBody.displayName = "TableBody"

const TableFooter = React.forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(({
  className, ...props 
}, ref) => (
  <tfoot
    ref={ref}
    className={cn(
      "bg-muted/50 [&>tr]_last_border-b-0 border-t font-medium",
      className
    )}
    {...props}
  />
))

TableFooter.displayName = "TableFooter"

const TableRow = React.forwardRef<
  HTMLTableRowElement,
  React.HTMLAttributes<HTMLTableRowElement>
>(({
  className, ...props 
}, ref) => (
  <tr
    ref={ref}
    className={cn(
      "hover_bg-muted/50 data-[state=selected]_bg-muted border-b transition-colors",
      className
    )}
    {...props}
  />
))

TableRow.displayName = "TableRow"

const TableHead = React.forwardRef<
  HTMLTableCellElement,
  React.ThHTMLAttributes<HTMLTableCellElement>
>(({
  className, ...props 
}, ref) => (
  <th
    ref={ref}
    className={cn(
      "text-muted-foreground [&_has([role=checkbox])]_pr-0 [&>[role=checkbox]_translate-y-[2px] h-10 px-2 text-left align-middle font-medium",
      className
    )}
    {...props}
  />
))

TableHead.displayName = "TableHead"

const TableCell = React.forwardRef<
  HTMLTableCellElement,
  React.TdHTMLAttributes<HTMLTableCellElement>
>(({
  className, ...props 
}, ref) => (
  <td
    ref={ref}
    className={cn(
      "[&_has([role=checkbox])]_pr-0 [&>[role=checkbox]]_translate-y-[2px] p-2 align-middle",
      className
    )}
    {...props}
  />
))

TableCell.displayName = "TableCell"

const TableCaption = React.forwardRef<
  HTMLTableCaptionElement,
  React.HTMLAttributes<HTMLTableCaptionElement>
>(({
  className, ...props 
}, ref) => (
  <caption
    ref={ref}
    className={cn("text-muted-foreground mt-4 text-sm", className)}
    {...props}
  />
))

TableCaption.displayName = "TableCaption"

export {
  Table, TableBody, TableCaption, TableCell, TableFooter,
  TableHead, TableHeader, TableRow
}

